import { useRef } from 'react';

import Tooltip from '@mui/material/Tooltip';

import StyledWrapper from '../IndividualProgram/style';
import { formatTimestamp } from '../../utils/dateUtils';

const BasicCellText = ({ cellValues, StartIcon, IconStatus, isDate }) => {
	//This is overflow will only add the tooltip on initial render. Not if the user adjusts the column sizing
	const cardRowInfoRef = useRef(null);

	const isOverflowing = cardRowInfoRef.current
		? cardRowInfoRef.current.scrollWidth > cardRowInfoRef.current.clientWidth
		: false;

	const formattedText = isDate
		? formatTimestamp(cellValues.formattedValue)
		: cellValues.formattedValue;

	return (
		<StyledWrapper.CellContainer>
			{cellValues.formattedValue && StartIcon && (
				<StartIcon width={'20px'} status={IconStatus} isCurrentStage={true} />
			)}
			<Tooltip
				arrow
				placement="top"
				title={isOverflowing && cellValues.formattedValue ? formattedText : ''}
			>
				<StyledWrapper.CardRowInfo ref={cardRowInfoRef} width={'100%'}>
					{cellValues.formattedValue ? formattedText : ''}
				</StyledWrapper.CardRowInfo>
			</Tooltip>
		</StyledWrapper.CellContainer>
	);
};

export default BasicCellText;
